import type { PeerConnectionEvent } from 'jssip/lib/RTCSession';

import { setIsCurrentCallOnFreeSwitch } from 'features/teaming/teaming-base/store';
import { SipSessionEventBus } from 'features/sip/services';
import { setDeafStatus } from 'features/call/call-deaf/store';
import { getCallState } from 'features/call/call-base/store';
import { handleError } from 'features/notification/store';
import type { CallAttemptConfig } from 'features/teaming/teaming-base/types';

// ===== CALL MANAGEMENT FUNCTIONS =====
export const createCallOptions = (sipHeaders: string[], sipConfig: any) => ({
  extraHeaders: sipHeaders,
  pcConfig: sipConfig.pcConfig,
  eventHandlers: {
    peerconnection: (event: PeerConnectionEvent) => {
      SipSessionEventBus.peerConnection$.next(event);
    },
    failed: () => {},
    confirmed: () => {},
    accepted: () => {},
  },
});

export const makeCallAttempt = async (
  config: CallAttemptConfig,
  dispatch: any,
  isRetry = false
): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    const options = createCallOptions(config.sipHeaders, config.sipConfig);
    const uriToCall = `${config.roomUri};transport=tcp`;

    options.eventHandlers = {
      ...options.eventHandlers,
      failed: () => resolve(false),
      confirmed: () => resolve(true),
      accepted: () => resolve(true),
    };

    try {
      if (isRetry) {
        dispatch(setDeafStatus('connecting'));
      }
      dispatch(getCallState());
      dispatch(setIsCurrentCallOnFreeSwitch());

      config.uaRef?.current?.call(uriToCall, options);
    } catch (error) {
      dispatch(handleError({ error, disableUserNotification: true }));
      resolve(false);
    }
  });
};
